// Stable avatar palette index for anonymous web visitors (Visitor 12 / 访客12).
// Uses contact id embedded in the display name so color is stable across UI locales.

const ZH_ANONYMOUS = /^访客(\d+)$/;
const EN_ANONYMOUS = /^Visitor\s*(\d+)$/i;

export const extractAnonymousVisitorId = name => {
  if (!name) return null;

  const trimmed = String(name).trim();
  const zhMatch = trimmed.match(ZH_ANONYMOUS);
  if (zhMatch) return zhMatch[1];

  const enMatch = trimmed.match(EN_ANONYMOUS);
  if (enMatch) return enMatch[1];

  return null;
};

const hashStringToIndex = (value, modulo) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0;
  }
  return hash % modulo;
};

const isAnonymousVisitorPlaceholder = name => {
  if (!name) return false;
  const trimmed = String(name).trim();
  return trimmed === 'Visitor' || trimmed === '访客';
};

export const avatarColorPaletteIndex = (name, paletteSize, colorSeed = null) => {
  const visitorId = extractAnonymousVisitorId(name);
  if (visitorId != null) {
    return hashStringToIndex(`visitor:${visitorId}`, paletteSize);
  }

  if (
    colorSeed != null &&
    colorSeed !== '' &&
    isAnonymousVisitorPlaceholder(name)
  ) {
    return hashStringToIndex(`visitor:${colorSeed}`, paletteSize);
  }

  if (!name) return 0;
  return name.length % paletteSize;
};
